import React from "react";
import CustomModal from "../CustomModal";
import { motion, AnimatePresence } from "framer-motion";
import {
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "@mui/material/styles";

const DocVerificationModal = ({ open, onClose, missingDocs, onNavigate }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Profile Verification Required"
      maxWidth="sm"
      showCloseButton
      customStyles={{
        "& .custom-modal-content": {
          width: isMobile ? "90%" : "400px",
          padding: isMobile ? "16px" : "24px",
          textAlign: "center",
        },
      }}
      actions={[
        {
          label: "Go to Profile",
          onClick: onNavigate,
          color: "primary",
          variant: "contained",
          sx: {
            borderRadius: 25,
            px: 2.5,
            py: 1,
            fontSize: "0.95rem",
            "&:hover": {
              transform: "translateY(-1px)",
              bgcolor: "primary.dark",
            },
          },
        },
      ]}
    >
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "100%", opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Box className="doc-verification-content" sx={{ mt: 1 }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                To proceed with booking, please ensure the following
                requirements are completed:
              </Typography>

              <List dense disablePadding sx={{ textAlign: "left", pl: 2 }}>
                {missingDocs.map((doc, index) => (
                  <ListItem key={index} sx={{ py: 0.5 }}>
                    <ListItemIcon sx={{ minWidth: 30 }}>
                      <CheckCircleIcon color="action" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={doc} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </CustomModal>
  );
};

export default DocVerificationModal;
